import * as React from "react";
import { View } from "./view";
import { useViewModel } from "./viewModel";

export default function Booking() {
  const viewModel = useViewModel();
  return <View {...viewModel} />;
}
